import { render, staticRenderFns } from "./WarrantyPeriodSetting.vue?vue&type=template&id=f0856fc2&scoped=true&"
import script from "./WarrantyPeriodSetting.vue?vue&type=script&lang=js&"
export * from "./WarrantyPeriodSetting.vue?vue&type=script&lang=js&"
import style0 from "./WarrantyPeriodSetting.vue?vue&type=style&index=0&id=f0856fc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0856fc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VRadio,VRadioGroup,VSelect,VTextField})
